module.exports = __webpack_public_path__ + "static/media/banner.fe780647.png";